import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';

import { actions as orderActions } from 'state/order';

import ErrorMessage from 'components/ErrorMessage/component';

const enhance = compose(
  connect(() => ({}), {
    navigateToForm: orderActions.navigateToForm,
    discardOrder: orderActions.discardOrder,
  }),
  withProps(({ shouldDiscard = false, discardOrder, navigateToForm }) => ({
    onClick: shouldDiscard ? discardOrder : navigateToForm,
  }))
);

export default enhance(ErrorMessage);
